<template>
    <Path>
        <template v-slot:path>
            <li><router-link :to="{name: 'dashboard'}" >الصفحة الرئيسية</router-link> </li>
            <li> <span class="divider"> / </span><a href="#"> أقرب سجل مدنى </a> </li>
        </template>
    </Path>

    <section>
        <div class="py-4 ">
            <div class="container">
                <div class="row">
                    <div class="col-12 mb-2 ">
                        <h1 class="blueFont py-3">أقرب سجل مدني</h1>

                        <div class="accordion" id="accordionExample">
                            <div class="accordion-item">
                                <h2 class="accordion-header" id="headingTwo">
                                    <button class="accordion-button  shadow-sm border rounded-3 my-4 collapsed"
                                        type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo"
                                        aria-expanded="false" aria-controls="collapseTwo">
                                        السجلات النموذجية
                                    </button>
                                </h2>
                                <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo"
                                    data-bs-parent="#accordionExample">
                                    <div class="accordion-body">
                                        <form name="form1" class="container human form-control" id="human">
                                            <div class="container">
                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <label style="margin: 10px;"> المحافظة: </label>
                                                        <select v-model="subjectSel" name="Gover" class="form-select" id="subject">
                                                            <option value="" selected="selected">اختر المحافظة</option>
                                                            <option v-for="gov in subjectGov" :key="gov" :value="gov">{{gov }}</option>
                                                        </select>

                                                        <label style="margin: 10px;"> الموقع:</label>
                                                        <select v-model="topicSel" name="" class="form-select" id="topic">
                                                            <option value="" selected="selected">اختر الموقع</option>
                                                            <option v-for="loc in subjectLoc" :key="loc" :value="loc">{{loc }}</option>
                                                        </select>
                                                        <br><br>
                                                        <div v-if="Detailes_Department" id="Detailes_Department">
                                                            <b>الخدمات المقدمة :</b>{{subServices}}  <br> 
                                                            <b>التشغيل :</b> {{subOps}}  <br> 
                                                            <b>نوع الخدمة المقدمة :</b> {{subServiceType}}  <br>
                                                        </div>
                                                    </div>

                                                    <div class="col-md-6 map">
                                                        <iframe width="100%" height="355" id="map"
                                                            src="https://maps.google.com/maps?q=%D9%85%D9%8A%D9%86%D8%A7%D8%A1%20%D8%A7%D9%84%D9%82%D8%A7%D9%87%D8%B1%D8%A9%20%D8%A7%D9%84%D8%AC%D9%88%D9%8A%20&t=&z=13&ie=UTF8&iwloc=&output=embed"
                                                            frameborder="0" style="border:0;" allowfullscreen=""
                                                            aria-hidden="false" tabindex="0">
                                                        </iframe>
                                                    </div>
                                                </div>
                                            </div>
                                            <br />
                                        </form>

                                    </div>
                                </div>
                            </div>

                            <div class="accordion-item">
                                <h2 class="accordion-header" id="headingThree">
                                    <button class="accordion-button  shadow-sm border rounded-3 my-4 collapsed"
                                        type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree"
                                        aria-expanded="false" aria-controls="collapseThree">
                                        السجلات الذكية
                                    </button>
                                </h2>
                                <div id="collapseThree" class="accordion-collapse collapse"
                                    aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                                    <div class="accordion-body">
                                        <form name="form1" class="container form-control" id="automated">
                                            <div class="container">
                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <label style="margin: 10px;"> المحافظة: </label>
                                                        <select v-model="governmentSel" name="Gover" class="form-select" id="government">
                                                            <option value="" selected="selected">اختر المحافظة</option>
                                                            <option v-for="gov in automatedGov" :key="gov" :value="gov">{{gov }}</option>
                                                        </select>

                                                        <label style="margin: 10px;"> الموقع:</label>
                                                        <select v-model="locationSel" name="" class="form-select" id="location">
                                                            <option value="" selected="selected">اختر الموقع</option>
                                                            <option v-for="loc in automatedLoc" :key="loc" :value="loc">{{loc }}</option>
                                                        </select>
                                                        <br><br>
                                                        <div v-if="Detailes_Department2" id="Detailes_Department2">
                                                            <b>الخدمات المقدمة :</b>{{autoServices}}  <br> 
                                                            <b>التشغيل :</b> {{autoOps}}  <br> 
                                                            <b>نوع الخدمة المقدمة :</b> {{autoServiceType}}  <br>
                                                        </div>
                                                    </div>

                                                    <div class="col-md-6 map">
                                                        <iframe width="100%" height="355" id="map2"
                                                            src="https://maps.google.com/maps?q=%D9%85%D9%8A%D9%86%D8%A7%D8%A1%20%D8%A7%D9%84%D9%82%D8%A7%D9%87%D8%B1%D8%A9%20%D8%A7%D9%84%D8%AC%D9%88%D9%8A%20&t=&z=13&ie=UTF8&iwloc=&output=embed"
                                                            frameborder="0" style="border:0;" allowfullscreen=""
                                                            aria-hidden="false" tabindex="0">
                                                        </iframe>
                                                    </div>
                                                </div>
                                            </div>
                                            <br />
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import Path from '@/components/Path.vue';
import sharedData from "@/shared/sharedData.js";

export default {
    name: 'LocationComp',
    components: { Path },
    created() {
        window.scrollTo({ top: 0, behavior: "smooth" });
    },
    data(){
        return{
            subjectSel:'',
            topicSel: '',

            governmentSel: '',
            locationSel: '',
            
            subjectLoc: Object,
            automatedLoc:Object,

            Detailes_Department:false,
            Detailes_Department2:false,

            subServices:'',
            subOps: '',
            subServiceType:'',

            autoServices:'',
            autoOps: '',
            autoServiceType:'',
        }
    },
    computed:{
        subjectGov(){
            return Object.keys(sharedData.subjectiveLocation)
        },
        automatedGov(){
            return Object.keys(sharedData.automatedLocation)
        }
    },
    watch:{
        subjectSel(newValue){
            if(newValue){
                this.subjectLoc = Object.keys(sharedData.subjectiveLocation[newValue]);
            }
        },
        governmentSel(newValue){
            if(newValue){
                this.automatedLoc = Object.keys(sharedData.automatedLocation[newValue]);
            }
        },

        topicSel(newValue){
            if(newValue){
                this.Detailes_Department = true;
                let topicdata = sharedData.subjectiveLocation[this.subjectSel][newValue];
                this.subServices  = topicdata[0];
                this.subOps = topicdata[1];
                this.subServiceType = topicdata[2];

                let loc = topicdata[3];
                document.getElementById('map').setAttribute('src', loc);
            }
        },

        locationSel(newValue){
            if(newValue){
                this.Detailes_Department2 = true;
                let locdata = sharedData.automatedLocation[this.governmentSel][newValue];
                this.autoServices  = locdata[0];
                this.autoOps = locdata[1];
                this.autoServiceType = locdata[2];

                let loc = locdata[3];
                document.getElementById('map2').setAttribute('src', loc);
            }
        },
    },
   
}

</script>